import {
  FormControl,
  Button,
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  useMediaQuery,
  Grid,
  Pagination,
  Alert,
  AlertTitle,
  TextField,
} from "@mui/material";
import { FormEvent, useEffect, useRef, useState } from "react";
import PauseCircleRoundedIcon from "@mui/icons-material/PauseCircleRounded";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import LayoutWithIcons from "./LayoutWithIcons";
import CommonModal from "./HWSubmitModal";
import { useCharactersContext } from "../hooks/Context";

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: { optionId: number; option: string; correctAnswer: string }[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface LayoutProps {
  Questions: Question[];
  sectionName: string;
}

const Layout1: React.FC<LayoutProps> = ({ Questions, sectionName }) => {
  //console.log("Layout1Questions:", Questions);

  //Find total marks
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentLayoutNumber, setCurrentLayoutNumber] = useState<number>(0);

  // const [modalOpen, setModalOpen] = useState(false);
  const {
    questionScores,
    setQuestionScores,
    isViewMode,
    examAnswers,
    setExamAnswers,
  } = useCharactersContext();
  const [layoutScore, SetLayoutScore] = useState<number>(0);
  const [isCorrectSubmission, setIsCorrectSubmission] = useState<
    boolean | null
  >(null);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  const [retryCount, setRetryCount] = useState(0);
  //console.log("Questions[0].uiType", Questions[0].uiType);
  useEffect(() => {
    setCurrentLayoutNumber(Questions[0].uiType);
  }, [Questions]);

  //console.log("currentLayoutNumber", currentLayoutNumber);

  const handleNavigate = (direction: "previous" | "next") => {
    if (direction === "previous") {
      setCurrentQuestionIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (direction === "next") {
      setCurrentQuestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, Questions.length - 1)
      );
    }
  };

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentQuestionIndex(value - 1);
  };

  const currentQuestion = Questions[currentQuestionIndex];
  console.log("currentQuestion", currentQuestion);
  const sentences = currentQuestion.question.split("<br>");
  const options = currentQuestion?.optionsList ?? [];
  const correctOptions = options
    .filter((option) => option.correctAnswer)
    .map((option) => option.option);

  const [selectedOptions, setSelectedOptions] = useState<string[][]>(() => {
    const storageKey = `selectedOptions${sectionName}_${currentQuestion.questionPaperId}`;
    const savedOptions = localStorage.getItem(storageKey);
    return savedOptions
      ? JSON.parse(savedOptions)
      : Array(Questions.length).fill([]);
  });

  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  const audioRef = useRef<HTMLAudioElement>(null);

  const handleOptionChange = (option: string) => {
    setSelectedOptions((prevSelectedOptions) => {
      const updatedOptions = [...prevSelectedOptions];
      const currentOptions = updatedOptions[currentQuestionIndex];

      const isSingleCorrectAnswer = correctOptions.length === 1;

      if (sectionName === "Syllabification" || isSingleCorrectAnswer) {
        updatedOptions[currentQuestionIndex] = [option];
      } else {
        if (currentOptions.includes(option)) {
          updatedOptions[currentQuestionIndex] = currentOptions.filter(
            (item) => item !== option
          );
        } else {
          updatedOptions[currentQuestionIndex] = [...currentOptions, option];
        }
      }

      return updatedOptions;
    });
  };

  const playCorrectSound = () => {
    const correctSound = new Audio(
      require("../assets/correct-choice-43861.mp3")
    );
    correctSound.play();
    // correctSound.onended = () => {
    //   window.alert("All options are correct!");
    // };
    // handleOpen();
  };

  const playInCorrectSound = () => {
    const incorrectSound = new Audio(
      require("../assets/wronganswer-37702.mp3")
    );
    incorrectSound.play();
    // handleOpen();
  };

  // const handleOpen = () => setModalOpen(true);

  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  setTimeout(handleAlertClose, 3000);

  const questionPaperId = currentQuestion.questionPaperId;

  const handleFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setShowAlert(true);
    //console.log("Selected options:", selectedOptions);

    const selectedForCurrentQuestion = selectedOptions[currentQuestionIndex];
    const isCorrect = correctOptions.every((option) =>
      selectedForCurrentQuestion.includes(option)
    );

    setIsCorrectSubmission(isCorrect);

    if (isCorrect) {
      // playCorrectSound();

      const questionIndex = questionScores.findIndex(
        (item) => item.questionBankId === currentQuestion.questionBankId
      );

      if (questionIndex !== -1) {
        // Update the existing score
        const updatedScores = [...questionScores];
        updatedScores[questionIndex] = {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: currentQuestion.marks,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        };
        setQuestionScores(updatedScores);
        // where layoutNumber === currentL
        const layoutScore = updatedScores.reduce(
          (sum, question) => sum + (question.score || 0),
          0
        );
        //console.log("layoutScore ", updatedScores);

        // Set the layout score
        SetLayoutScore(layoutScore);
      } else {
        // Add a new score for the question
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else {
      const correctSelections = selectedOptions[currentQuestionIndex].filter(
        (option) => correctOptions.includes(option)
      );

      if (correctSelections.length > 0) {
        // playInCorrectSound();
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      } else {
        // playInCorrectSound();
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    }

    //console.log("questionScores", questionScores);
    //console.log("UpdatedQuestionScores", setQuestionScores);

    const updatedExamAnswer = {
      questionBankId: currentQuestion.questionBankId,
      acutalOptionValue: correctOptions.join(","),
      enteredOptionValue: selectedOptions[currentQuestionIndex].join(","),
    };

    // Reset selectedOptions for the next question
    //setSelectedOptions([]);

    // Check if there is already an answer for the current question
    const existingAnswerIndex = examAnswers.findIndex(
      (answer) => answer.questionBankId === currentQuestion.questionBankId
    );

    if (existingAnswerIndex !== -1) {
      // If an answer already exists, update the existing one
      setExamAnswers((prevAnswers) =>
        prevAnswers.map((answer, index) =>
          index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
        )
      );
    } else {
      // If there is no existing answer, add the new answer
      setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
    }

    //console.log("updatedExamAnswer ", updatedExamAnswer);
    //console.log("examAnswers  ", examAnswers);
  };

  const handleAudioToggle = () => {
    if (audioRef.current) {
      if (isAudioPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsAudioPlaying(!isAudioPlaying);
    }
  };

  const handleAudioEnded = () => {
    setIsAudioPlaying(false);
  };

  // const handleContinue = () => {
  //   setCurrentQuestionIndex((prevIndex) =>
  //     Math.min(prevIndex + 1, Questions.length - 1)
  //   );
  //   setModalOpen(false);
  // };

  // const handleRetry = () => {
  //   setSelectedOptions([]);
  //   setModalOpen(false);

  //   if (retryCount < 1) {
  //     setRetryCount(retryCount + 1);
  //   } else {
  //     setCurrentQuestionIndex((prevIndex) =>
  //       Math.min(prevIndex + 1, Questions.length - 1)
  //     );
  //     setRetryCount(0);
  //   }
  // };

  // useEffect(() => {
  //   localStorage.setItem(
  //     "currentQuestionIndex",
  //     currentQuestionIndex.toString()
  //   );
  // }, [currentQuestionIndex]);

  useEffect(() => {
    const storageKey = `selectedOptions${sectionName}_${currentQuestion.questionPaperId}`;
    localStorage.setItem(storageKey, JSON.stringify(selectedOptions));
  }, [selectedOptions]);

  //console.log("isViewMode", isViewMode);

  useEffect(() => {
    // When isViewMode is true, set selectedOptions to the correctOptions
    if (isViewMode) {
      const newSelectedOptions = Array(Questions.length).fill(correctOptions);
      setSelectedOptions(newSelectedOptions);
      //console.log("correctOptions:", correctOptions);
    }
  }, [currentQuestion]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // marginBottom: "0px",
        marginTop:
          isMobile && isViewMode
            ? "17%"
            : isTablet
            ? "20%"
            : isMobile
            ? "10%"
            : isViewMode
            ? "6%"
            : "4%",

        marginBottom: "auto",
      }}
    >
      {showAlert && (
        <Alert
          severity="success"
          variant="filled"
          sx={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            padding: "0.5",
          }}
          // sx={{
          //   position: "fixed",
          //   bottom: "40px",
          //   right: "20px",
          //   zIndex: 9999,
          //   padding: "0.5",
          // }}
        >
          <AlertTitle sx={{ color: "white" }}>Answer submitted</AlertTitle>
        </Alert>
      )}
      <LayoutWithIcons onNavigate={handleNavigate}>
        {currentQuestion && (
          <Card
            variant="outlined"
            sx={{
              borderRadius: "12px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              // marginTop: "auto",
              minWidth: "40vw",
              pointerEvents: isViewMode ? "none" : "auto",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingBottom: "0px",
                }}
              >
                {currentQuestion.answerType === 2 ? (
                  <>
                    <Typography
                      sx={{
                        fontWeight: "700",
                        fontSize: isMobile ? "100%" : "110%",
                        textAlign: "center",
                        marginBottom: "10px",
                      }}
                    >
                      {sentences[0]}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: isMobile ? "95%" : "105%",
                        textAlign: "center",
                        color: "black",
                      }}
                    >
                      {sentences[1].split(" ").map((word, i) => {
                        const targetWord = sentences[2].trim().toLowerCase();
                        const currentWord = word.replace(/[.,!?;:]$/, "");
                        return (
                          <span
                            key={i}
                            style={{
                              color:
                                currentWord.toLowerCase() === targetWord ? "red" : "inherit",
                              fontWeight:
                                currentWord.toLowerCase() === targetWord ? "bold" : "normal",
                              marginRight: "4px",
                            }}
                          >
                            {word}
                          </span>
                        );
                      })}
                    </Typography>
                  </>
                ) : currentQuestion.answerType === 3 ? (
                  <>
                    <Typography
                      sx={{
                        fontWeight: "700",
                        fontSize: isMobile ? "100%" : "110%",
                        textAlign: "center",
                        marginBottom: "10px",
                      }}
                    >
                      {sentences[0]}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: isMobile ? "95%" : "105%",
                        textAlign: "center",
                        color: "black",
                        marginBottom: "6px",
                      }}
                    >
                      {sentences[1]}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: isMobile ? "95%" : "105%",
                        textAlign: "center",
                        color: "black",
                      }}
                    >
                      {sentences[2]}
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography
                      sx={{
                        fontWeight: "700",
                        fontSize: isMobile ? "100%" : "110%",
                      }}
                    >
                      {currentQuestion.question}
                    </Typography>
                    <audio
                      ref={audioRef}
                      src={currentQuestion.mediaUrl}
                      onEnded={handleAudioEnded}
                    ></audio>
                    <IconButton
                      onClick={handleAudioToggle}
                      sx={{
                        paddingBottom: "0px !important",
                        fontSize: "33px !important",
                        color: "#E12027 !important",
                        backgroundColor: "transparent !important",
                        "&:hover": {
                          backgroundColor: "transparent !important",
                        },
                        marginTop: "2px !important",
                      }}
                      title="Click to play audio"
                    >
                      {isAudioPlaying ? (
                        <PauseCircleRoundedIcon fontSize="inherit" />
                      ) : (
                        <VolumeUpRoundedIcon fontSize="inherit" />
                      )}
                    </IconButton>
                  </>
                )}
              </Box>

              <form onSubmit={handleFormSubmit}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                  }}
                >
                  <FormControl>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: "8px",
                        ...(isMobile && {
                          gap: "0px",
                        }),
                      }}
                    >
                      {currentQuestion.answerType === 3 ? (
                        <TextField
                          variant="standard"
                          sx={{
                              width:"150px",
                              backgroundColor: "lightcoral",
                              borderRadius: "5px",
                          }}
                          value={selectedOptions[currentQuestionIndex] || ""}
                          onChange={(event) => handleOptionChange(event.target.value)}
                        />
                      ) : (
                        options.map((option) => (
                          <Button
                            key={option.optionId}
                            onClick={() => handleOptionChange(option.option)}
                            variant={
                              selectedOptions[currentQuestionIndex].includes(
                                option.option
                              )
                                ? "contained"
                                : "outlined"
                            }
                            sx={{
                              m: 1,
                              backgroundColor: selectedOptions[
                                currentQuestionIndex
                              ].includes(option.option)
                                ? "#E12027"
                                : undefined,
                              "&:hover": {
                                backgroundColor: selectedOptions[
                                  currentQuestionIndex
                                ].includes(option.option)
                                  ? "#E12027"
                                  : undefined,
                              },
                              ...(isMobile && {
                                padding: "0.1vh 0.5vh",
                                minWidth: "1vh",
                                minHeight: "1vh",
                              }),
                            }}
                          >
                            {option.option}
                          </Button>
                        ))
                      )}
                    </Box>
                  </FormControl>
                </Box>
                {!isViewMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                    }}
                  >
                    <Button type="submit" variant="contained">
                      Submit
                    </Button>
                  </Box>
                )}
              </form>
            </CardContent>
          </Card>
        )}
        <Grid container lg={12} md={12} sm={12} xs={12} justifyContent="center">
          <Pagination
            count={Questions.length}
            shape="rounded"
            sx={{
              marginBottom: "1vh",
              paddingTop: "4%",
            }}
            page={currentQuestionIndex + 1}
            onChange={handlePaginationChange}
          />
        </Grid>
      </LayoutWithIcons>
    </div>
  );
};
export default Layout1;
